import React from 'react';

import { Box } from '@chakra-ui/react';
import impactHexagon from './impact-hexagon.svg';

const ImpactGraphic = (props: { widthRatio: number }) => (
  <Box
    flex={props.widthRatio}
    position="relative"
    overflow="hidden"
    display={{ base: 'none', md: 'block' }}
    pointerEvents="none"
    aria-hidden="true"
    role="presentation"
  >
    <Box
      position="absolute"
      insetY="13%"
      insetX={0}
      backgroundImage={impactHexagon}
      backgroundRepeat="no-repeat"
      backgroundSize="auto 100%"
    />
  </Box>
);

export default ImpactGraphic;
